<script setup>
import SignUpForm from '@/components/auth/SignUpForm.vue';
import { useRouter } from 'vue-router';
import { watch } from 'vue';
import { useAuthStore } from '@/stores/auth.js';
const auth = useAuthStore();
const router = useRouter();

watch(
  () => auth.user,
  (newUser) => {
    if (newUser) {
      router.push('/todo');
    }
  },
  { immediate: true },
); // ログイン済みの場合todo画面へ飛ばす
</script>
<template>
  <!-- 新規登録画面 -->
  <p class="mb-7"></p>
  <SignUpForm />
</template>
